import { colorsPalettes } from "@similarweb/styles";

const ONBOARDING_MODAL_MIN_PADDING = 32;
const ONBOARDING_MODAL_BORDER_WIDTH = 0;
const ONBOARDING_MODAL_WIDTH = 940;

export const ONBOARDING_MODAL_PADDING = (ONBOARDING_MODAL_MIN_PADDING + ONBOARDING_MODAL_BORDER_WIDTH) * 2;

export const ONBOARDING_MODAL_STYLES = {
    content: {
        padding: 0,
        borderRadius: 10,
        borderWidth: `${ONBOARDING_MODAL_BORDER_WIDTH}px`,
        boxShadow: "rgba(14, 30, 62, 0.12) 0px 18px 34px 0px",
        width: `${ONBOARDING_MODAL_WIDTH}px`,
        height: `644px`,
        maxWidth: ONBOARDING_MODAL_WIDTH,
        maxHeight: 720,
        overflow: "hidden",
        outline: "none",
    },
    overlay: {
        backgroundColor: colorsPalettes.bluegrey[100],
    },
};
